export const DEFAULT_ERROR_TITLE = 'An error has occurred!';
export const DEFAULT_ERROR_MESSAGE = 'Something went wrong.';

export enum ErrorCodeEnum {
  PasswordRequired = 'PasswordRequired',
  RequiredTwoFA = 'required_2fa',
  OutOfStock = 'OutOfStock',
  BudgetExceeded = 'budget_exceeded',
  AddressCountryNotAllowed = 'address_country_not_allowed',
  MarketplaceItemUnavailable = 'marketplace_item_unavailable',
  MarketplaceMultipleSuppliers = 'MarketplaceMultipleSuppliers',
  MarketplaceOrderFailed = 'MarketplaceOrderFailed',
}

export const CLAIM_KEPT_ERROR_CODES = [
  ErrorCodeEnum.OutOfStock,
  ErrorCodeEnum.BudgetExceeded,
  ErrorCodeEnum.AddressCountryNotAllowed,
  ErrorCodeEnum.MarketplaceItemUnavailable,
  ErrorCodeEnum.MarketplaceMultipleSuppliers,
  ErrorCodeEnum.MarketplaceOrderFailed,
];
